import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { usePrevious } from "@react-hookz/web";
import { useMultipleSelection } from "downshift";
import { useI18n } from "../../../i18n/i18n";
export var useMultipleSelectionCustom = function useMultipleSelectionCustom(_ref) {
  var isInteractive = _ref.isInteractive,
    itemToString = _ref.itemToString,
    rollupSelectionAfter = _ref.rollupSelectionAfter,
    onChange = _ref.onChange,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems;
  var _useI18n = useI18n(),
    i18n = _useI18n.i18n;
  var previousSelectedCount = usePrevious(selectedItems.length);
  var hookReturn = useMultipleSelection({
    getA11yRemovalMessage: function getA11yRemovalMessage(opts) {
      var removedSelectedItem = opts.removedSelectedItem,
        itemToString = opts.itemToString;

      // If our new count is 0, and the previous count was more than 1 item, the only way to
      // go from 2+ items to 0 is to click select all.
      // There's an edge case here if there is only 1 option in the multiselect, but we should
      // probably not show "select all" in that case...
      var selectAllClicked = opts.resultCount === 0 && previousSelectedCount !== undefined && previousSelectedCount > 1;
      if (selectAllClicked) {
        return i18n._( /*i18n*/"All items have been removed.");
      } else {
        return i18n._( /*i18n*/{
          id: "{itemAsString} has been removed.",
          values: {
            itemAsString: itemToString(removedSelectedItem)
          }
        });
      }
    },
    itemToString: itemToString,
    selectedItems: selectedItems,
    onSelectedItemsChange: function onSelectedItemsChange(change) {
      return onChange(change.selectedItems || []);
    },
    stateReducer: function stateReducer(state, _ref2) {
      var changes = _ref2.changes,
        type = _ref2.type;
      // Cancel the following events if the dropdown is non-interactive.
      switch (type) {
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
          if (!isInteractive) {
            return state;
          }
      }
      var isSelectionCombined = rollupSelectionAfter !== undefined && rollupSelectionAfter < state.selectedItems.length;
      switch (type) {
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
          // Only allow updating selected state when MS is interactive (not disabled & not readonly).
          return isInteractive ? changes : state;
        case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
          return _objectSpread(_objectSpread({}, changes), {}, {
            // If there's nothing selected, and backspace is pressed in an empty input,
            // normally downshift will delete the last chip and focus the one before
            // the deleted one. This is kinda weird; we'll just keep the input focused.
            activeIndex: state.activeIndex === -1 ? -1 : changes.activeIndex
          });
        case useMultipleSelection.stateChangeTypes.DropdownKeyDownNavigationPrevious:
          {
            var inputFocused = state.activeIndex === -1;
            if (inputFocused && isSelectionCombined) {
              return _objectSpread(_objectSpread({}, changes), {}, {
                // If the "go to previous chip" key is pressed (ArrowLeft) and the input is
                // focused, we need to check to see if we're currently rolling any items up.
                // If we are, we need to tell downshift to focus the rolled-up chip which
                // has an activeIndex much less than selectedItems.length -1.
                activeIndex: rollupSelectionAfter
              });
            } else {
              return changes;
            }
          }
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownNavigationNext:
          {
            var isCombinedChipFocused = state.activeIndex === rollupSelectionAfter;
            return _objectSpread(_objectSpread({}, changes), {}, {
              // If we're focused on the combined chip an ArrowRight should
              // focus the input.
              activeIndex: isSelectionCombined && isCombinedChipFocused ? -1 : changes.activeIndex
            });
          }
      }
      return changes;
    }
  });
  var selectedItemSet = new Set(selectedItems);
  return _objectSpread({
    isItemSelected: function isItemSelected(option) {
      return selectedItemSet.has(option);
    }
  }, hookReturn);
};
//# sourceMappingURL=useMultipleSelectionCustom.js.map